import { batch } from 'react-redux';

// This re-write of redux-thunk was made because of https://jira.paysera.net/browse/TICKETS-1950
export default ({ dispatch, getState }) => next => (action) => {
    if (typeof action === 'function') {
        return action(fn => batch(() => dispatch(fn)), getState);
    }

    return next(action);
};
